import { useParamsSearch } from '@anytag/shared-hooks';
import { AutoManagedReportSearchSchemaType } from '../schemaTypes';

export const useAutoManagedReportFilter = () => useParamsSearch<AutoManagedReportSearchSchemaType>();
